import React from "react";
import SideBar from "./SideBar";
import NucleationImage from "../../Images/2_Nucleation.jpg";

const Nucleation = () => {
  return (
    <div className="container">
      <div className="row">
        <div className="col-lg-3">
          <SideBar nucleation={true} />
        </div>
        <div className="col-lg-9 padding-lg">
          <div className="heading mt-5">Nucleation: Supercooled Water</div>
          <hr />
          <div className="row">
            <div className="col-md-7">
              <p className="mb-auto textAlign">
                Ice nucleation from supercooled water is a widespread phenomenon
                that has strong impacts the viability of life at cold
                temperatures, cryopreservation of biological materials, and
                Earth’s climate through glaciation on cloud properties. Here, we
                investigate the ice nucleation mechanism on solid smooth, and
                nanotextured surfaces, organic crystal surfaces, and in the
                presence of biological ice nucleating proteins. We apply
                all-atom and coarse-grained molecular dynamics simulation to
                understand the molecular insight into nucleation and growth of
                ice and the ordering of interfacial water to assess the key
                roles of pre-ordering, lattice mismatch, and hydrogen bond on
                nucleation efficiency. These findings could be essential in
                designing suitable materials for improving anti-icing efficiency
                or potent ice nucleant in various industrial processes and
                applications.
              </p>
            </div>
            <div className="col-md-5 text-center">
              <div className="card-text mb-auto research p-3">
                <img src={NucleationImage} alt="" />
              </div>
            </div>
          </div>
          <div className="heading mt-4">Related Publications</div>
          <hr />
          <div className="mb-4 textAlign">
            <li className="mb-1">
              Atanu K. Metya and Valeria Molinero,
              &nbsp;<a
                href="https://doi.org/10.1021/jacs.0c12012"
                target={"_blank"}
                className="remove-underline"
              >
                <font color="808000">
                  "Is Ice Nucleation by Organic Crystals Nonclassical? An
                  Assessment of the Monolayer Hypothesis of Ice Nucleation".
                </font>
              </a>
              <font color="008080">
                J. Am. Chem. Soc. (2021), 143, 12, 4607-4624.
              </font>
            </li>
            <li className="mb-1">
              Pavithra M. Naullage#, Atanu K. Metya#, and Valeria Molinero,
              &nbsp;<a
                href="https://doi.org/10.1063/5.0021631"
                target={"_blank"}
                className="remove-underline"
              >
                <font color="808000">
                  "Computationally Efficient Approach for the Identification of
                  Ice-Binding Surfaces and How They Bind Ice".
                </font>
              </a>
              <font color="008080"> J. Chem. Phys. (2020), 153, 174106. </font>
            </li>
            <li className="mb-1">
              Prerna, Rohit Goswami, Atanu K. Metya, S. V. Shevkunov, and Jayant
              K. Singh,
              &nbsp;<a
                href="https://doi.org/10.1080/00268976.2019.1657599"
                target={"_blank"}
                className="remove-underline"
              >
                <font color="808000">
                  "Study of Ice Nucleation on Silver Iodide Surface with
                  Defects".
                </font>
              </a>
              <font color="008080"> Mol. Phys. (2019), 117, 3651-3663. </font>
            </li>
            <li className="mb-1">
              Atanu K. Metya and Jayant K Singh,
              &nbsp;<a
                href="https://doi.org/10.1080/08927022.2018.1513649"
                target={"_blank"}
                className="remove-underline"
              >
                <font color="808000">
                  "Ice Adhesion Mechanism on Lubricant-Impregnated Surfaces
                  using Molecular Dynamics Simulations".
                </font>
              </a>
              <font color="008080"> Mol. Simul. (2019), 45, 394–402. </font>
            </li>
            <li className="mb-1">
              Atanu K. Metya and Jayant K Singh,
              &nbsp;<a
                href="https://doi.org/10.1021/acs.jpcc.8b05989"
                target={"_blank"}
                className="remove-underline"
              >
                <font color="808000">
                  "Ice Nucleation on a Graphite Surface in the Presence of
                  Nanoparticles".
                </font>
              </a>
              <font color="008080">
                J. Phys. Chem. C (2018), 122, 19056−19066.
              </font>
            </li>
            <li className="mb-1">
              Atanu K. Metya and Jayant K Singh,
              &nbsp;<a
                href="https://doi.org/10.1021/acs.jpcc.7b12495"
                target={"_blank"}
                className="remove-underline"
              >
                <font color="808000">
                  "Nucleation of Aqueous Sal Solutions on Solid Surfaces".
                </font>
              </a>
              <font color="008080">
                J. Phys. Chem. C (2018), 122, 8277–8287.
              </font>
            </li>
            <li className="mb-1">
              Atanu K. Metya, Jayant K Singh, and Florian Muller-Plathe,
              &nbsp;<a
                href="https://doi.org/10.1039/C6CP04382H"
                target={"_blank"}
                className="remove-underline"
              >
                <font color="808000">
                  "Ice nucleation on nanotextured surfaces: Influence of surface
                  fraction, pillar height and wetting states".
                </font>
              </a>
              <font color="008080">
                Phys. Chem. Chem. Phys. (2016), 18, 26796-26806.
              </font>
            </li>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Nucleation;
